module.exports = __webpack_public_path__ + "img/web_iosxz_btn.4de15733.png";